import * as React from "react";
import { useLocation } from "wouter";
import { useTheme } from "next-themes";
import { ArrowLeft, Check } from "lucide-react";

const THEMES = [
  {
    id: "light",
    name: "Cyan Blue + White",
    description: "Clean and bright, the default look.",
    swatchClass: "bg-gradient-to-br from-white to-slate-100 border",
    accentClass: "bg-gradient-to-br from-blue-500 to-cyan-400",
  },
  {
    id: "dark",
    name: "Cyan Blue + Deep Blue",
    description: "Easy on the eyes in low light.",
    swatchClass: "bg-gradient-to-br from-slate-900 to-slate-800",
    accentClass: "bg-gradient-to-br from-blue-500 to-cyan-400",
  },
  {
    id: "black",
    name: "Cyan Blue + Pitch Black",
    description: "Deep true black for maximum contrast.",
    swatchClass: "bg-black",
    accentClass: "bg-gradient-to-br from-blue-500 to-cyan-400",
  },
];

export function ThemesPage() {
  const [, setLocation] = useLocation();
  const { theme, setTheme } = useTheme();

  return (
    <div className="max-w-4xl mx-auto min-h-[calc(100dvh-4rem)] flex flex-col px-4">
      <div className="pt-6 pb-4 shrink-0 flex items-center gap-3">
        <button
          type="button"
          onClick={() => {
            if (window.history.length > 1) {
              window.history.back();
            } else {
              setLocation("/");
            }
          }}
          className="h-9 w-9 rounded-full border flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors shrink-0"
          aria-label="Back"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
        <h2 className="text-lg font-semibold">Themes</h2>
      </div>

      <p className="text-sm text-muted-foreground mb-4">
        Choose a complete look for Rememly. More themes coming soon.
      </p>

      <div className="grid grid-cols-2 gap-3 pb-6">
        {THEMES.map(({ id, name, description, swatchClass, accentClass }) => {
          const isSelected = theme === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => setTheme(id)}
              className={`text-left rounded-2xl border p-3 transition-colors ${
                isSelected
                  ? "border-primary ring-2 ring-primary/30"
                  : "hover:border-primary/40"
              }`}
            >
              <div
                className={`relative h-24 w-full rounded-xl overflow-hidden mb-3 ${swatchClass}`}
              >
                <div
                  className={`absolute bottom-2 left-2 h-6 w-6 rounded-full ${accentClass}`}
                />
                {isSelected && (
                  <div className="absolute top-2 right-2 h-5 w-5 rounded-full bg-primary flex items-center justify-center">
                    <Check className="h-3 w-3 text-primary-foreground" />
                  </div>
                )}
              </div>
              <p className="text-sm font-semibold">{name}</p>
              <p className="text-xs text-muted-foreground mt-0.5">
                {description}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
